import React, { useState, useMemo, useEffect } from "react";
import {
  Container,
  AssetCard,
  AssetItem,
  AssettField,
  EmptyMessage,
  Pagination,
  BtnPagination,
  BtnClose,
  BtnNav,
  Title,
  TitleField,
  ValueField,
  DateFilterContainer,
  DateInputWrapper,
  DateInput,
  DateLabel
} from './styles';

const ShowAsset = ({ account_address, assets, onClose }) => {
  const [page, setPage] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const itemsPerPage = 1;

  const filteredAssets = useMemo(() => {
    if (!assets || assets.length === 0) return [];

    return assets.filter(asset => {
      const assetDate = new Date(asset.created_date); // Use created_date instead
      if (startDate && new Date(startDate) > assetDate) return false;
      if (endDate && new Date(endDate) < assetDate) return false;
      return true;
    });
  }, [assets, startDate, endDate]);

  const totalPages = Math.ceil(filteredAssets.length / itemsPerPage);
  const currentItems = filteredAssets.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );

  useEffect(() => {
    setPage(0);
  }, [filteredAssets]);

  // Fechar popup ao pressionar ESC
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEsc);

    // Prevenir scroll do body quando o modal está aberto
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  // Fechar ao clicar no overlay (fora do card)
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handlePrevPage = () => {
    setPage(prev => Math.max(prev - 1, 0));
  };

  const handleNextPage = () => {
    setPage(prev => Math.min(prev + 1, totalPages - 1));
  };

  return (
    <Container onClick={handleOverlayClick}>
      <AssetCard>
        <BtnClose onClick={onClose}>×</BtnClose>

        <Title>Detalhes do Pacote de Créditos</Title>

        {filteredAssets.length === 0 ? (
          <EmptyMessage>Nenhum asset encontrado para este período.</EmptyMessage>
        ) : (
          <>
           

            {currentItems.map((asset, index) => (
              <AssetItem key={index}>
                <AssettField>
                  <TitleField>Nome do Asset:</TitleField>
                  <ValueField>{asset.asset_name}</ValueField>
                </AssettField>
                <AssettField>
                  <TitleField>Tipo:</TitleField>
                  <ValueField>{asset.asset_type}</ValueField>
                </AssettField>
                <AssettField>
                  <TitleField>Quantidade Emitida:</TitleField>
                  <ValueField>{asset.quantity_issued}</ValueField>
                </AssettField>
                <AssettField>
                  <TitleField>Data de Criação:</TitleField>
                  <ValueField>{new Date(asset.created_date).toLocaleDateString()}</ValueField>
                </AssettField>
                <AssettField>
                  <TitleField>Padrão:</TitleField>
                  <ValueField>{asset.standard}</ValueField>
                </AssettField>
                <AssettField>
                  <TitleField>Safra:</TitleField>
                  <ValueField>{asset.vintage}</ValueField>
                </AssettField>
                <AssettField>
                  <TitleField>Tipo de Projeto:</TitleField>
                  <ValueField>{asset.project_type}</ValueField>
                </AssettField>
                <AssettField>
                  <TitleField>Número Serial:</TitleField>
                  <ValueField style={{ wordBreak: 'break-all', fontSize: '12px' }}>{asset.serial_number}</ValueField>
                </AssettField>
              </AssetItem>
            ))}

            {/* Pagination */}
            {totalPages > 1 && (
              <Pagination>
                <BtnNav onClick={handlePrevPage} disabled={page === 0}>
                  Anterior
                </BtnNav>
                {Array.from({ length: totalPages }, (_, i) => (
                  <BtnPagination
                    key={i}
                    active={i === page}
                    onClick={() => setPage(i)}
                  >
                    {i + 1}
                  </BtnPagination>
                ))}
                <BtnNav onClick={handleNextPage} disabled={page === totalPages - 1}>
                  Próxima
                </BtnNav>
              </Pagination>
            )}
          </>
        )}
      </AssetCard>
    </Container>
  );
};

export default ShowAsset;